import { render, staticRenderFns } from "./dashboardHeader.vue?vue&type=template&id=b5cac8e8&scoped=true"
import script from "./dashboardHeader.vue?vue&type=script&lang=js"
export * from "./dashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./dashboardHeader.vue?vue&type=style&index=0&id=b5cac8e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cac8e8",
  null
  
)

export default component.exports